import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-12 bg-aged-green relative overflow-hidden" data-id="element-178">
      <div className="container mx-auto px-4" data-id="element-179">
        <div className="max-w-3xl mx-auto" data-id="element-180">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center space-y-8" data-id="element-181">
            <h2 className="text-3xl md:text-4xl font-bold text-[#f4c430] text-stroke-black-lg" style={{
            filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.5)) drop-shadow(0 8px 16px rgba(0,0,0,0.4)) drop-shadow(0 12px 24px rgba(0,0,0,0.3))'
          }} data-id="element-182">
              La quincena no debería doler
            </h2>
            <p className="text-xl text-white/90" data-id="element-183">Pero ahora mismo, duele.</p>

            <div className="space-y-4 text-lg text-white/90" data-id="element-184">
              <p data-id="element-185">Duele cuando revisas la cuenta.</p>
              <p data-id="element-186">
                Duele cuando compras algo para ti y te castigas mentalmente.
              </p>
              <p data-id="element-187">Duele cuando prometes que "el próximo mes será distinto".</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 mt-12 relative overflow-hidden" data-id="element-188">
              <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent pointer-events-none" data-id="element-189" />
              <p className="text-lg text-white mb-6 italic relative z-10" data-id="element-190">
                Y en silencio aparece el miedo.
              </p>
              <div className="space-y-3 text-white/90 relative z-10" data-id="element-191">
                <p data-id="element-192">¿Y si nunca salgo de vivir al día?</p>
                <p data-id="element-193">¿Y si repito la historia financiera de mi familia?</p>
                <p data-id="element-194">¿Y si nunca aprendo a manejar el dinero?</p>
              </div>
              <p className="text-lg font-medium text-[#f4c430] mt-6 relative z-10" data-id="element-195">
                Ese miedo no se dice en voz alta. Pero pesa.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}